import { render } from "./ErrorBoundary.vue?vue&type=template&id=64a31325&scoped=true"
import script from "./ErrorBoundary.vue?vue&type=script&lang=js"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js"

import "./ErrorBoundary.vue?vue&type=style&index=0&id=64a31325&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a31325"]])

export default __exports__